import { useMutation } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';
import { ApiResponse, createCharacter } from '~/api';
import userKey from '~/features/user/userKey';
import {
  ApiError,
  CreateCharacterRequest,
  CreateCharacterResponse,
} from '~/types';
import useToast from '~/store/useToast';

// abort controller 사용을 위해 -> axios 호출 사용

const useCreateCharacterMutation = () => {
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation<
    ApiResponse<CreateCharacterResponse>,
    ApiError,
    CreateCharacterRequest
  >({
    mutationFn: createCharacter,
    onSuccess: ({ status }, request) => {
      queryClient.invalidateQueries({
        queryKey: userKey.getMyCreation(),
      });
    },
    onError: (error) => {
      if (error.status === 400) {
        showToast(
          'error',
          'Image upload failed. Pornographic or inappropriate images cannot be uploaded.',
        );
      } else {
        showToast('error', 'Failed to create character.');
      }
      console.error(error);
    },
  });
};

export default useCreateCharacterMutation;
